import { useTranslate } from '@tolgee/react';
import { scenarioTypeI18nLabelMap } from 'views/Aide/Scenario/config';

export const useScenarioLabel = (scenarioType: Marketing.AllScenarioType) => {
  const { t } = useTranslate();

  return t(scenarioTypeI18nLabelMap[scenarioType]) as string;
};

export const useGetCheckDisplay = () => {
  const { t } = useTranslate();

  return (value: any, text: string) => {
    return value
      ? t('TaskOperationLog.checked', { text })
      : t('TaskOperationLog.unchecked', { text });
  };
};

export const useGetSwitchDisplay = () => {
  const { t } = useTranslate();

  return (value: any) => {
    return value ? t('TaskOperationLog.opened') : t('TaskOperationLog.closed');
  };
};
